import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
  Popover,
  withStyles,
  WithStyles,
} from '@material-ui/core';
import {default as DeleteIcon} from '@material-ui/icons/Delete';
import {default as MoreVertIcon} from '@material-ui/icons/MoreVert';
import {default as EditIcon} from '@material-ui/icons/Edit';
import {default as SendIcon} from '@material-ui/icons/Send';
import {default as RestoreIcon} from '@material-ui/icons/Restore';
import {default as BlockIcon} from '@material-ui/icons/Block';
import {default as LockOpenIcon} from '@material-ui/icons/LockOpen';
import {FamilyMemberType} from '@services/family/family.constants';
import * as React from 'react';
import {IFamilyMember} from '@app-types/websocket/family.types';
import ImgAvatar from '@components/common/avatar/ImgAvatar';
import TranslateNew from '@translate/TranslateNew';
import { standardFamilyColors } from '@services/family/family.utils';
import { DialogTop } from '@components/economy/DialogComponens';
import CloseIcon from '@material-ui/icons/CloseRounded';
import Button from '@components/common/button/Button';
import {FamilyListStyle as styles} from './FamilyList.style';
import { styleColors } from 'src/main.style';


const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof styles>{
  myID: number;
  myRole: FamilyMemberType;
  family: IFamilyMember[];
  onInvite: (id: number ) => void;
  onDelete: (id: number ) => void;
  onUnlimit: (id: number ) => void;
  onRestore: (id: number ) => void;
  onNudgeToLogIn: (id: number ) => void;
  onUpdate: (id: number ) => void;
  updateFamilyColors: (accountId:number, color:string) => void;
}

interface IState {
  anchorEl: HTMLButtonElement|null;
  currentUser: IFamilyMember|undefined;
  colorSelectOpen: boolean;
  verifyDelete:number|undefined;
  restoreDialogOpen: boolean;
  nudgeDialogOpen: boolean;
}



class FamilyList extends React.Component<IProps, IState> {
  private colorRef:React.RefObject<HTMLLIElement> = React.createRef();

  constructor(props: IProps) {
    super(props);
    this.state = {
      anchorEl: null,
      currentUser: undefined,
      colorSelectOpen:false,
      verifyDelete:undefined,
      restoreDialogOpen:false,
      nudgeDialogOpen:false,
    };
  }

  public render() {
    const classes = this.props.classes;
    const selectedFM:IFamilyMember|undefined = this.state.currentUser;
    const deleteUser:IFamilyMember|undefined = this.props.family.find((f) => f.id === this.state.verifyDelete)
    const deleteName = deleteUser ? deleteUser.firstName : tn.lang.unknown;
    const deleteIsChild = deleteUser !== undefined && deleteUser.role === FamilyMemberType.CHILD;
    // The server limits instead of deleting an important adult the other parent invited.
    const deleteInviter = deleteUser !== undefined ? this.otherInvitingParent(deleteUser) : undefined;

    return (
      <div className={classes.familyList}>
        {
          this.props.family.filter(
            (mem: IFamilyMember) => mem.role === FamilyMemberType.CHILD
              || mem.role === FamilyMemberType.PARENT
              || mem.role === FamilyMemberType.MODERATOR
              || mem.role === FamilyMemberType.VIEWER
              || mem.id === this.props.myID).map(
            (member, index) => {
              const primaryText = `${member.firstName} ${member.lastName ? member.lastName : ""}`;
              const isDeletedAccount = this.isDeletedAccount(member);
              let secondaryText = '';
              if (isDeletedAccount) {
                secondaryText = tn.lang.restoreAccountDeletedHelper;
              } else if (!member.online) {
                if (member.lastOnline === 0) {
                  if (member.inviteTime > 0) {
                    secondaryText = tn.lang.settingsUserStatusInvited(
                      member.inviteEmail, tn.lang.momentFromNow(member.inviteTime)
                    );
                  } else {
                    secondaryText = tn.lang.settingUserStatusNotInvited;
                  }
                } else {
                  secondaryText = tn.lang.settingUserStatusLastSeen(
                    tn.lang.momentFromNow(member.lastOnline)
                  );
                }
              } else {
                secondaryText = tn.lang.settingUserStatusOnline;
              }
              return (
                <div className={classes.familyItem} key={index}>
                   <div
                   className={classes.familyContent}
                  >
                    <span onClick={() => {
                      if ((member.lastOnline === 0 || member.id === this.props.myID)
                        || (this.props.myRole === FamilyMemberType.PARENT && member.role === FamilyMemberType.CHILD)) {
                          this.setState({currentUser: member});
                          this.handleClose();
                          this.props.onUpdate(member.id);
                      }
                    }} >
                      <ImgAvatar imgName={member.avatar}  color={member.color} 
                        imgUrl={member.imageAvatar?member.avatarURL:undefined} />
                    </span>
                    <div>
                      <p className={`${classes.primaryText} ${isDeletedAccount ? classes.deletedPrimaryText : ""}`}>
                        {primaryText}
                      </p>
                      <p className={classes.secondaryText}>
                        {this.isLimited(member) ? tn.lang.limitedAccess : tn.lang.role(member.role)}
                      </p>
                      <p className={classes.secondaryText}>{secondaryText}</p>
                    </div>
                  </div>

                  <ListItemSecondaryAction>
                    <IconButton
                      onClick={(evt) => this.handleClick(member, evt.currentTarget)}
                      aria-haspopup="true"
                    >
                      <MoreVertIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </div>
              );
            })
        }
        <Menu
          open={Boolean(this.state.anchorEl)}
          anchorEl={this.state.anchorEl}
          onClose={this.handleClose}
        >
          {(selectedFM !== undefined && this.isDeletedAccount(selectedFM)) ?
              (
                <MenuItem onClick={this.handleRestoreAccount}>
                  <ListItemIcon>
                    <RestoreIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={tn.lang.restoreAccount}
                  />
                </MenuItem>
              ) :
              null
          }
          {(selectedFM !== undefined
            && this.canNudgeToLogIn(selectedFM)) ?
              (
                <MenuItem onClick={this.handleNudgeToLogIn}>
                  <ListItemIcon>
                    <SendIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={tn.lang.nudgeToLogIn}
                  />
                </MenuItem>
              ) :
              null
          }
          {(selectedFM !== undefined
            && (selectedFM.lastOnline === 0
              && (selectedFM.role === FamilyMemberType.PARENT
                || selectedFM.role === FamilyMemberType.VIEWER
                || selectedFM.role === FamilyMemberType.CHILD))) ?
              (
                <MenuItem onClick={() => this.handleInvite()}>
                  <ListItemIcon>
                    <SendIcon />
                  </ListItemIcon>
                  <ListItemText>
                    {tn.lang.invite}
                  </ListItemText>
                </MenuItem>
              ) :
              null
          }
          {
            (selectedFM !== undefined && (selectedFM.lastOnline === 0 || selectedFM.id === this.props.myID)) ?
              (
                <MenuItem onClick={this.handleUpdate}>
                  <ListItemIcon>
                    <EditIcon />
                  </ListItemIcon>
                  <ListItemText>
                    {tn.lang.edit}
                  </ListItemText>
                </MenuItem>
              ) :
              null
          }
          {
            (this.props.myRole === FamilyMemberType.PARENT 
              && selectedFM !== undefined
              && selectedFM.lastOnline !== 0
              && selectedFM.role === FamilyMemberType.CHILD) ?
              (
                <MenuItem onClick={this.handleUpdate}>
                  <ListItemIcon>
                    <EditIcon />
                  </ListItemIcon>
                  <ListItemText>
                    {tn.lang.edit}
                  </ListItemText>
                </MenuItem>
              ) :
              null
          }
          {
            (selectedFM !== undefined && this.canUnlimit(selectedFM)) ?
              (
                <MenuItem onClick={this.handleUnlimit}>
                  <ListItemIcon>
                    <LockOpenIcon />
                  </ListItemIcon>
                  <ListItemText>
                    {tn.lang.unlimitAccess}
                  </ListItemText>
                </MenuItem>
              ) :
              null
          }
          {
            (selectedFM !== undefined && this.otherInvitingParent(selectedFM) !== undefined) ?
              (
                // Limiting someone already limited changes nothing.
                !this.isLimited(selectedFM) ?
                  <MenuItem onClick={() => this.setState({verifyDelete:selectedFM.id, anchorEl:null})}>
                    <ListItemIcon>
                      <BlockIcon />
                    </ListItemIcon>
                    <ListItemText>
                      {tn.lang.limitAccess}
                    </ListItemText>
                  </MenuItem>
                  : null
              ) :
            (selectedFM !== undefined 
              && ((selectedFM.id === this.props.myID
                  && (selectedFM.role === FamilyMemberType.MODERATOR || selectedFM.role === FamilyMemberType.EXPERT))
                || (this.props.myRole === FamilyMemberType.PARENT 
                  && (selectedFM.role === FamilyMemberType.CHILD || selectedFM.role === FamilyMemberType.VIEWER)))) ?
              (
                <MenuItem onClick={() => {if (selectedFM !== undefined) {this.setState({verifyDelete:selectedFM.id, anchorEl:null})}}}>
                  <ListItemIcon>
                    <DeleteIcon />
                  </ListItemIcon>
                  <ListItemText>
                    {tn.lang.delete}
                  </ListItemText>
                </MenuItem>
              ) :
              null
          }
          <MenuItem onClick={() => this.setState({colorSelectOpen:!this.state.colorSelectOpen})} ref={this.colorRef}>
            <ListItemIcon>
              <div style={{minWidth:24, minHeight:24, backgroundColor:this.state.currentUser
                ?this.state.currentUser.color:styleColors.white}}/>
            </ListItemIcon>
            <ListItemText>
              {tn.lang.color}
            </ListItemText>
          </MenuItem>
        </Menu>
        <Popover 
          disableScrollLock={true}
          anchorEl={this.colorRef.current}
          onClose={() => this.setState({colorSelectOpen:false})}
          open={(this.state.colorSelectOpen)}
          classes={{paper:this.props.classes.colorPaper}}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <div>{tn.lang.settingsColorChoice}</div>
          {standardFamilyColors.map((c) => <div key={c} style={{backgroundColor:c}} 
            className={this.props.classes.colorOption}
            onClick={() => this.setColor(this.state.currentUser?this.state.currentUser.id:undefined, c)}/>)}
        </Popover>
        <Dialog
          open={this.state.verifyDelete !== undefined}
          onClose={() => this.setState({verifyDelete:undefined})}
          >
          <DialogTop>
            <DialogTitle>
              {deleteInviter !== undefined ? tn.lang.limitAccess + "?"
                : deleteIsChild ? tn.lang.deleteChildWarningTitle : tn.lang.delete+"?"}
            </DialogTitle>
            <IconButton onClick={() => {this.setState({verifyDelete:undefined});}}>
              <CloseIcon />
            </IconButton>
          </DialogTop>
          <DialogContent style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
            {deleteInviter !== undefined ? tn.lang.limitAccessWarning(deleteName)
            : deleteIsChild ? (
              <>
                <span>{tn.lang.deleteChildWarning(deleteName)}</span>
                <span>{tn.lang.deleteChildWarningNotUser}</span>
                <strong>{tn.lang.deleteChildWarningOnlyIf}</strong>
              </>
            ) : tn.lang.delete + " " + deleteName + "?"}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({verifyDelete:undefined})} size="medium">
              {tn.lang.cancel}
            </Button>
            <Button onClick={() => this.handleDelete()} color='secondary' variant='contained' size="medium">
              {deleteInviter !== undefined ? tn.lang.limitAccess : tn.lang.delete}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.restoreDialogOpen}
          onClose={() => this.setState({restoreDialogOpen:false})}
        >
          <DialogTop>
            <DialogTitle>{tn.lang.restoreAccount}</DialogTitle>
            <IconButton onClick={() => {this.setState({restoreDialogOpen:false});}}>
              <CloseIcon />
            </IconButton>
          </DialogTop>
          <DialogContent>
            {tn.lang.restoreAccountInstructionsSent}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({restoreDialogOpen:false})} size="medium">
              {tn.lang.OK}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.nudgeDialogOpen}
          onClose={() => this.setState({nudgeDialogOpen:false})}
        >
          <DialogTop>
            <DialogTitle>{tn.lang.nudgeToLogIn}</DialogTitle>
            <IconButton onClick={() => {this.setState({nudgeDialogOpen:false});}}>
              <CloseIcon />
            </IconButton>
          </DialogTop>
          <DialogContent>
            {tn.lang.nudgeToLogInInstructionsSent}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({nudgeDialogOpen:false})} size="medium">
              {tn.lang.OK}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  public setColor = (userId:number|undefined, color:string) => {
    if (userId !== undefined) {
      this.props.updateFamilyColors(userId, color)
    }
    this.setState({colorSelectOpen:false, anchorEl: null})
  }

  public handleClose = () => {
    this.setState({ anchorEl: null, verifyDelete:undefined });
  }

  private handleClick = (member: IFamilyMember, anchor:HTMLButtonElement) => {
    this.setState({
      currentUser: member,
      anchorEl: anchor
    });
  }

  private handleInvite = () => {
    this.handleClose();
    if (this.state.currentUser !== undefined) {
      this.props.onInvite(this.state.currentUser.id);
    }
  }

  private handleDelete = () => {
    this.handleClose();
    if (this.state.currentUser !== undefined) {
      this.props.onDelete(this.state.currentUser.id);
    }
  }

  private handleUnlimit = () => {
    this.handleClose();
    if (this.state.currentUser !== undefined) {
      this.props.onUnlimit(this.state.currentUser.id);
    }
  }

  private handleRestoreAccount = () => {
    this.handleClose();
    if (this.state.currentUser !== undefined) {
      this.props.onRestore(this.state.currentUser.id);
      this.setState({restoreDialogOpen:true});
    }
  }

  private handleNudgeToLogIn = () => {
    this.handleClose();
    if (this.state.currentUser !== undefined) {
      this.props.onNudgeToLogIn(this.state.currentUser.id);
      this.setState({nudgeDialogOpen:true});
    }
  }

  private handleUpdate = () => {
    this.handleClose();
    if (this.state.currentUser !== undefined) {
      this.props.onUpdate(this.state.currentUser.id);
    }
  }

  private isDeletedAccount = (member: IFamilyMember|undefined): boolean => {
    return member !== undefined && String(member.clientVersion) === "-1";
  }

  private isLimited = (member: IFamilyMember): boolean => {
    return member.role === FamilyMemberType.VIEWER && member.limitedBy != null;
  }

  /**
   * The other parent who invited this important adult, while they are still a parent here. Then my
   * delete only limits the adult to view only, as the server does.
   */
  private otherInvitingParent = (member: IFamilyMember): IFamilyMember|undefined => {
    if (this.props.myRole !== FamilyMemberType.PARENT
      || member.role !== FamilyMemberType.VIEWER
      || member.invitedBy == null
      || member.invitedBy === this.props.myID) {
      return undefined;
    }
    return this.props.family.find((m) => m.id === member.invitedBy && m.role === FamilyMemberType.PARENT);
  }

  /** The parent who set the limit lifts it, or a moderator; any parent once that parent is gone. */
  private canUnlimit = (member: IFamilyMember): boolean => {
    if (!this.isLimited(member)) {
      return false;
    }
    if (this.props.myRole === FamilyMemberType.MODERATOR || member.limitedBy === this.props.myID) {
      return true;
    }
    return this.props.myRole === FamilyMemberType.PARENT
      && !this.props.family.some((m) => m.id === member.limitedBy && m.role === FamilyMemberType.PARENT);
  }

  private canNudgeToLogIn = (member: IFamilyMember): boolean => {
    const twentyFourHoursAgo = Date.now() - (1000 * 60 * 60 * 24);

    return !this.isDeletedAccount(member)
      && member.id !== this.props.myID
      && member.lastOnline !== 0
      && member.lastOnline <= twentyFourHoursAgo
      && !member.online
      && (member.role === FamilyMemberType.PARENT
        || member.role === FamilyMemberType.VIEWER
        || member.role === FamilyMemberType.CHILD);
  }

}

export default withStyles(styles)(FamilyList);



// WEBPACK FOOTER //
// ./src/components/extended-family/family-list/FamilyList.tsx